<template>
  <div class="toolWarp">
    <!--    店铺头部-->
    <div class="toolPanel" v-if="activeComponent.type == 'header'">
      <shop-top></shop-top>
    </div>
    <!-- 轮播图 -->
    <div class="toolPanel" v-if="activeComponent.type == 'banner'">
      <banner></banner>
    </div>
    <!-- 菜单 -->
    <div class="toolPanel" v-if="activeComponent.type == 'menu'">
      <menus></menus>
    </div>
    <!-- 公告 -->
    <div class="toolPanel" v-if="activeComponent.type == 'adv'">
      <adv></adv>
    </div>
    <!-- 菜单 -->
    <div class="toolPanel" v-if="activeComponent.type == 'noticeBar'">
      <noticeBar></noticeBar>
    </div>
    <!--    文本控件-->
    <div class="toolPanel" v-if="activeComponent.type == 'text'">
      <text-tool></text-tool>
    </div>
    <!--    视频控件-->
    <div class="toolPanel" v-if="activeComponent.type == 'videoBox'">
      <video-tool></video-tool>
    </div>
    <!--    图文控件-->
    <div class="toolPanel" v-if="activeComponent.type == 'imageText'">
      <image-text></image-text>
    </div>
    <!--    自定义控件-->
    <div class="toolPanel" v-if="activeComponent.type == 'custom'">
      <custom-tool></custom-tool>
    </div>
    <!--    品牌列表-->
    <div class="toolPanel" v-if="activeComponent.type == 'brandList'">
      <brand-list></brand-list>
    </div>
    <!--    图文列表-->
    <div class="toolPanel" v-if="activeComponent.type == 'imageTextList'">
      <image-text-list></image-text-list>
    </div>
    <!--    优惠券-->
    <div class="toolPanel" v-if="activeComponent.type == 'coupon'">
      <coupon-tool></coupon-tool>
    </div>
    <!--    类别列表-->
    <div class="toolPanel" v-if="activeComponent.type == 'categoryList'">
      <category-list></category-list>
    </div>
    <!--    商品列表-->
    <div class="toolPanel" v-if="activeComponent.type == 'productList'">
      <product-list></product-list>
    </div>
  </div>
</template>
<script>
import shopTop from './BasicsComp/shopTop'
import banner from './BasicsComp/banner'
import menus from './BasicsComp/menus'
import adv from './BasicsComp/adv'
import noticeBar from './BasicsComp/noticeBar'
import textTool from './BasicsComp/textTool'
import videoTool from './BasicsComp/videoTool'
import imageText from './BasicsComp/imageText'
import customTool from './BasicsComp/customTool'
import brandList from './BasicsComp/brandList'
import imageTextList from './BasicsComp/imageTextList'
import couponTool from './MarketingComp/couponTool'
import categoryList from './goodsComp/categoryTool'
import productList from './goodsComp/productList'
import { mapGetters } from 'vuex'
export default {
  name: 'toolPanel',
  components: {
    shopTop,
    banner,
    menus,
    adv,
    noticeBar,
    textTool,
    videoTool,
    imageText,
    customTool,
    brandList,
    imageTextList,
    couponTool,
    categoryList,
    productList
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['activeComponent'])
  }
}
</script>

<style lang="scss" scoped>
.toolWarp {
  width: 320px;
}
.toolPanel {
  width: 320px;
}
.toolPanel::-webkit-scrollbar {
  width: 4px;
  height: 1px;
}

.toolPanel::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 5px rgba(156, 148, 148, 0.2);
  background: #cdcdcd;
}
.toolPanel::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(158, 150, 150, 0.2);
  border-radius: 4px;
  background: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/rootcompToolbar/toolPanel.vue